<template>
    <div class="merge-customer">
        <div class="back-button-container" :class="{disabled: merging}" @click="cancelMerge">
            <img class="back-button" src="@/assets/BackPurple.svg"/>
            <div class="back-button-text">{{ $t('form.merge.back') }}</div>
        </div>
        <h1>{{ $t('form.merge.heading') }}</h1>
        <div class="description">{{ $t('form.merge.description') }}</div>
        <div class="customers">
            <div class="customer current-customer">
                <div class="label">{{ $t('form.merge.current_customer') }}</div>
                <div class="customer-data">
                    <div class="icon"><img src="@/assets/NewCust.svg"></div>
                    <div class="name">{{ currentCustomer.name }}</div>
                </div>
            </div>
            <div class="customer target-customer">
                <div class="label">{{ $t('form.merge.merge_with') }}</div>
                <div class="customer-data">
                    <div class="icon"><img src="@/assets/NewCust.svg"></div>
                    <div class="name">{{ targetCustomer.name }}</div>
                </div>
            </div>
        </div>
        <div class="preview">
            <div class="icon"><img src="@/assets/MergeButton.svg"></div>
            <div class="target-customer-name">{{ targetCustomer.name }}</div>
        </div>
        <div class="controls">
            <div class="action-button solid-button confirm-button"
                :class="{disabled: merging}"
                @click="confirmMerge"
            >
                <Spinner class="spinner" v-if="merging" :size="32"/>
                <div v-else  class="label">{{ $t('form.merge.confirm_merge') }}</div>
            </div>
            <div class="action-button outline-button"
                :class="{disabled: merging}"
                @click="cancelMerge"
            >
                <div class="label">{{ $t('form.merge.return') }}</div>
            </div>
        </div>
    </div>

</template>

<script>
import * as types from '@/store/mutations'
import Spinner from '@/components/core/Spinner.vue'

export default {
  name: 'ParticipantForm',
  components: { Spinner },
  emits: ['merged'],
  computed: {
    currentCustomer(){
        let id = this.$route.params.id
        let customer = this.$store.getters.getCustomer(id)
        if(customer){
            customer.name = `${customer.firstName} ${customer.lastName}`.trim()
        }
        return customer
    },
      targetCustomer(){
          let id = this.$store.state.customers.merge.target
          let customer = this.$store.getters.getCustomer(id)
        if(customer){
            customer.name = `${customer.firstName} ${customer.lastName}`.trim()
        }
        return customer
    },
    merging(){
        return this.$store.state.customers.merge.merging
    }
  },
  methods: {
    async confirmMerge(){
        try {
            let newId = await this.$store.dispatch('mergeCustomers', {
                current: this.currentCustomer.id,
                target: this.targetCustomer.id
            })
            this.$emit('merged', newId)
        } catch(err) {
            console.log("mergeCustomers failed",err)
        }
    },
    cancelMerge(){
        this.$store.commit(types.MERGE_PICKTARGET, null)
    }
  }
}
</script>

<style scoped>
.merge-customer {
  padding: 20px;
  padding-top: 30px;
  max-width: 100%;
}

.back-button-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}

.back-button {
  width: 24px;
  height: 24px;
}

.back-button-text {
  padding-left: 12px;
  font-size: 14px;
  line-height: 21px;
  color: #435152;
}

.back-button-container.disabled {
    pointer-events: none;
    opacity: 0.5;    
}

h1 {
  font-family: Rando;
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
  text-align: left;
  color: #435152;
  padding-top: 6px;
  margin-bottom: 0;
  padding-bottom: 0;
}

.description {
    margin-top: 16px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    letter-spacing: -0.16px;
}

.customers {
    display: flex;
    flex-direction: row;
    margin-top: 28px;
}

.current-customer {
    margin-right: 45px;
}

.customer-data {
    margin-top: 7px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.customer .label {
    font-size: 12px;
    letter-spacing: .084em;
    color: #687374;
    text-transform: uppercase;
}

.customer .icon {
    margin-right: 8px;
}
.customer .name {
    margin-top: 3px;
    font-size: 16px;
    font-weight: bold;
}

.preview {
    text-align: center;
    margin-top: 30px;
}
.preview .target-customer-name {
    font-family: Rando;
    font-weight: 500;
    color: #3B8524;
    font-size: 32px;
    margin-top: 24px;
}

.controls {
    margin-top: 42px;
    display: flex;
    flex-flow: column;
    max-width: 334px;
    margin-left: auto;
    margin-right: auto;
}

.action-button {
    border-radius: 25px;
    font-family: "Circular Std";
    font-weight: 600;
    font-size: 16px;
    height: 44px;
    display: flex;
    flex-shrink: 1;
    padding-left: 24px;
    padding-right: 24px;
    transition: all 0.15s ease-in;
    cursor: pointer;
    align-items: center;
    justify-content: center;
}
.solid-button {
    background: #435152;
    color: #F7F9F9;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
}
.solid-button:hover {
    background: #252f2f;
}

.action-button.disabled {
    pointer-events: none;
}

.solid-button.disabled {
    background: #E2E2E6;
    box-shadow: none;
}
.outline-button.disabled {
    color: #c0c0c3;
    border-color: transparent;
}

.outline-button {
    background: rgba(247, 249, 249, 0.5);
    border: 1px solid rgba(107, 71, 96, 0.25);
    color: #435152;
}
.outline-button:hover {
    background-color: #e7e9e9;
}
.confirm-button {
    margin-bottom: 20px;
}
</style>
